/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Photo_UnsupportedInputs */

const en_us2_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photos have to be JPEG. Take them again in the app.`)
};

const pt_br2_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos precisam estar em JPEG. Tire de novo pelo app.`)
};

const es_419_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fotos tienen que estar en JPEG. Tómalas de nuevo en la app.`)
};

const pt_pt2_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotografias têm de estar em JPEG. Tira-as outra vez na app.`)
};

const fr_fr2_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les photos doivent être en JPEG. Reprends-les dans l'appli.`)
};

const de_de2_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Fotos müssen JPEG sein. Nimm sie in der App neu auf.`)
};

const it_it2_body_assessment_photo_unsupported = /** @type {(inputs: Body_Assessment_Photo_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le foto devono essere in JPEG. Scattale di nuovo nell'app.`)
};

/**
* | output |
* | --- |
* | "The photos have to be JPEG. Take them again in the app." |
*
* @param {Body_Assessment_Photo_UnsupportedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_photo_unsupported = /** @type {((inputs?: Body_Assessment_Photo_UnsupportedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Photo_UnsupportedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_photo_unsupported(inputs)
	if (locale === "es-419") return es_419_body_assessment_photo_unsupported(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_photo_unsupported(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_photo_unsupported(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_photo_unsupported(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_photo_unsupported(inputs)
	return en_us2_body_assessment_photo_unsupported(inputs)
});
export { body_assessment_photo_unsupported as "body_assessment.photo_unsupported" }